// extracted by mini-css-extract-plugin
module.exports = {"base":"submittedSearchItem_base__LIhP8","name":"submittedSearchItem_name__3eqG0","submimttedTextContainer":"submittedSearchItem_submimttedTextContainer__2Z_8k"};